import DeviceDataInOneStep from "../../Canvas/DeviceDataInOneStep";
import CanvasVerticalDividerList from "../../Canvas/CanvasVerticalDividerList";
import TechnologyLineListForCanvas from "../../Canvas/TechnologyLineListForCanvas";
import { CanvasChildrenProps } from "../../../components/Canvas/CanvasContainer";

type AnalysisCanvasProps = {} & CanvasChildrenProps;

const AnalysisCanvas = (props: AnalysisCanvasProps) => {
  return (
    <>
      <DeviceDataInOneStep {...props} />
      <CanvasVerticalDividerList {...props} />
      <TechnologyLineListForCanvas {...props} />
    </>
  )
}

export default AnalysisCanvas;